<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>{{ $route.meta.title }}</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-danger card-outline collapsed-card">
                        <div class="card-header">
                            <div class="card-title">Data Filters</div>
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button
                                    type="button"
                                    class="btn btn-tool"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body overflow-auto">
                            <br />
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Select From Date:</span
                                            >
                                            <input
                                                type="date"
                                                class="form-control"
                                                v-model="from_date"
                                                placeholder="Select From date"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Select To Date:</span
                                            >
                                            <input
                                                type="date"
                                                class="form-control"
                                                v-model="to_date"
                                                placeholder="Select To date"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Branch:</span
                                            >
                                            <v-select
                                                v-model="branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branchv"
                                                :reduce="
                                                    (branchv) =>
                                                        branchv.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branchv) =>
                                                        branchv.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="
                                                    getData('/api/branchGP')
                                                "
                                            >
                                                <i class="fa fa-search"></i>
                                                Search
                                            </button>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    @click="reset"
                                                >
                                                    <i class="fa fa-times"></i>
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-secondary"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    @click="excel"
                                                >
                                                    <i class="fa fa-print"></i>
                                                    Export
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-12"> -->
                    </div>
                </div>
                <br />
                <br />

                <div class="col-md-12">
                    <div class="row" align="center">
                        <div class="col-lg-4 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ total }}</h3>
                                    <p>Total</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-person-add"></i>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ spare }}</h3>
                                    <p>Total Spares</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-pie-graph"></i>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ profit }}</h3>
                                    <p>Total Profit</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-bag"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />

                <div class="col-sm-12 overflow-auto">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card card-danger card-outline">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h5>Report</h5>
                                        </div>
                                        <!-- <div class="col-sm-6">
                 <button class="btn btn-primary float-right" @click="exportPms"><i class="fa fa-print"></i> Export</button>
               </div> -->
                                    </div>
                                </div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <!-- all amounts are pre-tax -->
                                                <th>Branch</th>
                                                <th>Total</th>
                                                <th>Spare</th>
                                                <th>Profit</th>
                                                <!-- list all job categories -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="branch in branches">
                                                <td>
                                                    {{ branch.BRANCH_NAME }}
                                                </td>
                                                <td>
                                                    {{ branch.total }}
                                                </td>
                                                <td>
                                                    {{ branch.spare }}
                                                </td>
                                                <td>
                                                    {{ branch.profit }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <!--<pagination :pagination="pagination"
       				@prev="getData(pagination.prevPageUrl)"
        			@next="getData(pagination.nextPageUrl)"
      			></pagination>-->
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
                <br />
                <br />
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
// import Pagination from '../../pagination.vue';
export default {
    //components: {pagination:Pagination},

    mounted() {
        console.log("Component mounted.");
    },

    created() {
        var date = new Date();
        const today = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
        )
            .toISOString()
            .split("T")[0];
        this.from_date = today;
        this.to_date = today;
        this.getBranches();
        this.getData();
    },

    data() {
        return {
            branches: [],
            branchv: [],
            to_date: "",
            from_date: "",
            total: "",
            spare: "",
            profit: "",
            branch: "",
            /*pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},*/
        };
    },

    methods: {
        /*configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},*/

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branchv = response.data;
            });
        },

        getData(url = "/api/branchGP") {
            axios
                .post(url, {
                    from: this.from_date,
                    to: this.to_date,
                    branch: this.branch,
                })
                .then((response) => {
                    this.branches = response.data.data;
                    this.total = response.data.total;
                    this.spare = response.data.spare;
                    this.profit = response.data.profit;
                    //this.configPagination(response.data.data);
                });
        },

        excel() {
            axios({
                url: "/api/branchGPExport",
                data: { from: this.from_date, to: this.to_date },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "gp_report.xlsx");
            });
        },

        reset() {
            var date = new Date();
            const today = new Date(
                date.getTime() - date.getTimezoneOffset() * 60000
            )
                .toISOString()
                .split("T")[0];
            this.from_date = today;
            this.to_date = today;
            this.branch = "";
            this.getData();
        },
    },
};
</script>
